import { faGear } from "@fortawesome/pro-solid-svg-icons";
import useI18n from "@i18n";
import { LinearProgress, linearProgressClasses, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";

import Icon from "@Components/generic/icon";
import { LoadingContainerStack } from "@Components/training-plans/training-plans-drawer/training-plans-drawer.styled";

const TrainingPlansDrawerLoadingState = ({ isBuilding }: { isBuilding: boolean }) => {
  const { i18n } = useI18n();
  const descriptionKey = isBuilding
    ? "training-plans.drawer.building.description"
    : "training-plans.drawer.loading.description";

  return (
    <LoadingContainerStack spacing={3} role="status" aria-live="polite">
      <Icon icon={faGear} size="2xl" />
      <Typography variant="textBase400" color="text.secondary" textAlign="center">
        {i18n(descriptionKey)}
      </Typography>
      <LinearProgress
        aria-hidden="true"
        variant="indeterminate"
        sx={theme => ({
          backgroundColor: alpha(theme.palette.dsBase.v200, 0.08),
          borderRadius: theme.spacing(1),
          height: theme.spacing(0.75),
          width: "50%",
          [`& .${linearProgressClasses.bar}`]: {
            backgroundColor: theme.palette.dsPrimary.v300,
          },
          [`& .${linearProgressClasses.bar1Indeterminate}, & .${linearProgressClasses.bar2Indeterminate}`]: {
            animationDuration: "2.4s",
          },
          "@media (prefers-reduced-motion: reduce)": {
            [`& .${linearProgressClasses.bar}`]: {
              animation: "none",
              transform: "translateX(-25%) scaleX(0.5)",
            },
          },
        })}
      />
    </LoadingContainerStack>
  );
};

export default TrainingPlansDrawerLoadingState;
